import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import Typography from "@mui/material/Typography";

import dayjs from "dayjs";

import { Formik } from "formik";
import * as Yup from "yup";

const Schema = Yup.object().shape({
  nume: Yup.string().required("Obligatoriu"),
  email: Yup.string()
    .email("Introduceti o adresa de email valida")
    .required("Adresa de email este obligatorie"),
  confirm_email: Yup.string()
    .email("Introduceti o adresa de email valida")
    .required("Confirma adresa de email")
    .oneOf([Yup.ref("email")], "Adresa de email nu este identica"),
  phone: Yup.string()
    .min(10, "Introduceti un numar valid")
    .matches(
      /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
      "Introduceti un numar valid"
    )
    .required("Numarul de telefon este obligatoriu"),
  confirm_phone: Yup.string()
    .required("Confirma numarul de telefon")
    .oneOf([Yup.ref("phone")], "Numarul  de telefon nu este identic"),
});

export default function AppForm({ app, slot, onApp }) {
  //   const handleSubmit = (event) => {
  //     event.preventDefault();
  //     const data = new FormData(event.currentTarget);
  //     console.log({
  //       p_name: data.get("nume"),
  //       p_email: data.get("email"),
  //       confirm_email: data.get("confirm_email"),
  //       confirm_phone: data.get("confirm_phone"),
  //       p_phone: data.get("phone"),
  //     });
  //   };

  return (
    <Formik
      initialValues={{
        nume: "",
        email: "",
        confirm_email: "",
        phone: "",
        confirm_phone: "",
      }}
      validationSchema={Schema}
      onSubmit={(data) => {
        // console.log("formik data", data);
        onApp(data);
      }}
    >
      {({
        values,
        touched,
        errors,
        handleSubmit,
        handleChange,
        handleBlur,
        isValid,
      }) => {
        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: 1,
            }}
          >
            <Typography component="h1" variant="h6">
              Programare noua
            </Typography>
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 1, width: "100%" }}
            >
              <Paper elevation={3} sx={{ p: 1, backgroundColor: "#e8e8e8" }}>
                <Grid container>
                  <Grid
                    item
                    xs={1}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      mr: 2,
                      pt: -1,
                    }}
                  >
                    <CalendarMonthIcon
                      color="primary"
                      sx={{ fontSize: "5em" }}
                    />
                  </Grid>
                  <Grid item>
                    Data:{" "}
                    <strong>
                      {dayjs(app.start_time).format("DD MMMM YYYY @ HH:mm")}
                    </strong>
                    <br />
                    Service: <strong>{slot.service_type}</strong>
                    <br />
                    Doctor: <strong>{slot.doctor}</strong>
                  </Grid>
                </Grid>
              </Paper>
              <TextField
                margin="normal"
                required
                fullWidth
                id="nume"
                label="Nume"
                name="nume"
                size="small"
                autoComplete="nume"
                value={values.nume}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.nume ? errors.nume : ""}
                error={touched.nume && Boolean(errors.nume)}
              />
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email"
                    name="email"
                    size="small"
                    autoComplete="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.email ? errors.email : ""}
                    error={touched.email && Boolean(errors.email)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="confirm_email"
                    label="Confirma Email"
                    name="confirm_email"
                    size="small"
                    autoComplete="confirm_email"
                    value={values.confirm_email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.confirm_email ? errors.confirm_email : ""
                    }
                    error={
                      touched.confirm_email && Boolean(errors.confirm_email)
                    }
                  />
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="phone"
                    label="Telefon"
                    name="phone"
                    size="small"
                    autoComplete="phone"
                    value={values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder=""
                    helperText={
                      touched.phone
                        ? errors.phone
                        : "adaugati un numar de forma 0711222333"
                    }
                    error={touched.phone && Boolean(errors.phone)}
                  />{" "}
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="confirm_phone"
                    label="Confirma Telefon"
                    name="confirm_phone"
                    size="small"
                    autoComplete="confirm_phone"
                    value={values.confirm_phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.confirm_phone ? errors.confirm_phone : ""
                    }
                    error={
                      touched.confirm_phone && Boolean(errors.confirm_phone)
                    }
                  />
                </Grid>
              </Grid>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={!isValid}
                sx={{ mt: 3, mb: 2 }}
              >
                Adauga Programare
              </Button>
            </Box>
          </Box>
        );
      }}
    </Formik>
  );
}
